import { useRef } from 'react';
import deepequal from 'fast-deep-equal/react.js';

// Hook
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useMemoCompare = <T = any>(next: T, compare: (prevToCompare: T, nextToCompare: T) => boolean): T => {
  // Ref for storing previous value
  const previousRef = useRef(next);
  const previous = previousRef.current;
  // Pass previous and next value to compare function
  // to determine whether to consider them equal.
  const isEqual = compare(previous, next);
  // If not equal update previousRef to next value.
  // We only update if not equal so that this hook continues to return
  // the same old value if compare keeps returning true.
  if (!isEqual) previousRef.current = next;
  // Finally, if equal then return the previous value
  return isEqual ? previous : next;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useMemoMergePropsWithDefault = <T = Record<string, any>>(
  props: Partial<T>,
  defaultProps: Partial<T>,
  compare = deepequal,
): T => {
  const mergedProps = { ...defaultProps, ...props } as T;

  return useMemoCompare<T>(mergedProps, compare);
};
